import { render, staticRenderFns } from "./BattleCrewDetailsModal.vue?vue&type=template&id=2f8f4c80&scoped=true"
import script from "./BattleCrewDetailsModal.vue?vue&type=script&lang=js"
export * from "./BattleCrewDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./BattleCrewDetailsModal.vue?vue&type=style&index=0&id=2f8f4c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8f4c80",
  null
  
)

export default component.exports